import React from 'react';
import { Container } from 'react-bootstrap';
import { SkeletonTable } from '../../components/Skeleton/Table';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <SkeletonTable className="card-table" />
    </Container>
  );
};

export default Loading;
